/**
 * Information aux écoles et à leurs partenaires (OCAS compris).
 * Depuis le 7 octobre 2026, l'application, la base de données et les documents
 * tournent sur une machine Infomaniak en Suisse. Cette mention est reprise dans
 * les conventions et les exports : elle ne doit affirmer que ce qui est vérifié.
 */
export const HOSTING_NOTICE =
  "Les dossiers sont enregistrés en Suisse, chez Infomaniak. Chaque école reste responsable de ses données. Le dossier n'est pas envoyé aux États-Unis.";
